module.exports = __webpack_public_path__ + "img/legal.e9d5b3c6.svg";